// src/components/ErrorScreen.js
import React from 'react';
import '../../index.css'; // Optional: For custom styling

export const ErrorScreen = ({ errorMessage, onRetry }) => {
    return (
        <div className="error-screen">
            <div className="error-container">
                <h1>Oops! Something went wrong.</h1>
                <p>{errorMessage}</p>
                <button className="reload-button" onClick={onRetry}>
                    Retry
                </button>
            </div>
        </div>
    );
}

export default ErrorScreen;
